import { Param } from "../../../query-options";
import { HomePageActionDialogReturnObj, PerformActionParamObj } from "../extras";
import { HomePageActionBase } from "./home-page-base-action"
import { IHomePageAction } from "./i-home-page-action";

export class SubscribeFolderAction extends HomePageActionBase implements IHomePageAction {

    public getTitle(): string {
        return "Subscribe to Folder";
    }

    public permissionsRequiredToPerform(): string {
        return "CanViewFolder";
    }

    public requiresTree(): boolean {
        return true;
    }

    public performAction(paramObj: PerformActionParamObj): Promise<HomePageActionDialogReturnObj> {
        let returnObj = new HomePageActionDialogReturnObj();
        returnObj.subscribeFolderId = paramObj.folderId;

        return new Promise((resolve) => {
            resolve(returnObj);
        });
    }

}
